<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import UploadPreview from "./UploadPreview.vue";
import UploadHeader from "./UploadHeader.vue";

const store = useStore();
const preview = computed(() => store.getters["artwork/artworkUrl"]);
const loading = computed(() => store.getters["loading/uploadArtwork"]);
const isUploadInProgress = computed(() => store.getters["loading/isUploadInProgress"]);
const artwork = computed(() => store.getters["artwork/artwork"]);
</script>

<template>
  <div v-if="artwork || loading" class="upload js-upload">
    <div class="upload__header">
      <UploadHeader />
    </div>

    <UploadPreview :preview="preview" :loading="isUploadInProgress" />
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/pod/settings";

.upload {
  padding: $indent-mobile-constructor;
  max-width: $container-width;
  margin: 0 auto;

  &__header {
    margin: 0 auto 10px;
  }
}
</style>
